import { render, staticRenderFns } from "./InternalAgencyPageAccessModal.vue?vue&type=template&id=0b950b9e&"
import script from "./InternalAgencyPageAccessModal.vue?vue&type=script&lang=js&"
export * from "./InternalAgencyPageAccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports